import { useSelector } from '@topwrite/common';

export default function useInPreview() {

    const { preview = false } = useSelector('options');

    return preview;
}
